import {fptiEvents} from "../utils/fptiConstants";

const recordClick = (eventData = {}) => {
  if (
    window &&
    window.PAYPAL &&
    window.PAYPAL.analytics &&
    window.PAYPAL.analytics.instance &&
    window.PAYPAL.analytics.instance.recordClick
  ) {
    const options = {
      data: {
        ...eventData ,
      },
    }
    window.PAYPAL.analytics.instance.recordClick(options)
  }
}

const logFPTIError = (error, source, errorDisplayed) => {
  if (window && window.PAYPAL && window.PAYPAL.analytics) {
    window.PAYPAL.analytics.logJSError(error, source, errorDisplayed)
  }
}

const logAPIPerformance = (start, end, url, eventName, spaceKey) => {
  if (window.PAYPAL && window.PAYPAL.analytics) {
    const data = {
      url, //An endpoint if logging the performance for ajax requests
      action: fptiEvents.API_PERFORMANCE, //Phase that is being measured for performance e.g. PAGE_LOADED, FORM_LOADED etc
      start, //Start timestamp in Unix Time
      end, //End timestamp in Unix Time, if not provided current timestamp is taken
        event_name: eventName,
        space_key: spaceKey, //Space key for the event, 'SKYGOV' is used
    }
    window.PAYPAL.analytics.logPerformance(data)
  }
}

export default {
  recordClick,
  logAPIPerformance,
  logFPTIError,
}
